<tt-page *ngIf="!!deviationSource2Keyno">
    <tt-deviation-source2 [deviationSource2Keyno]="deviationSource2Keyno" (onSave)="onDeviationSource2Save()" (onDelete)="onDeviationSource2Delete()"></tt-deviation-source2>
</tt-page>
